// 관련 리소스로 이동하는 링크. 내부(react-router) / 외부(새 탭) 모두 지원.
// 대상(to)이나 라벨이 없으면 렌더하지 않는다.

import React from "react";
import Link from "@mui/material/Link";
import { Link as RouterLink } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import type { SxProps, Theme } from "@mui/material/styles";

export interface RelatedLinkProps {
  to: string;
  label?: string;
  external?: boolean;
  sx?: SxProps<Theme>;
  className?: string;
}

export const RelatedLink: React.FC<RelatedLinkProps> = ({
  to,
  label = "바로가기",
  external = false,
  sx,
  className,
}) => {
  if (!to || !label) return null;

  const baseSx: SxProps<Theme> = {
    display: "inline-flex",
    alignItems: "center",
    gap: 0.25,
    fontSize: "0.8125rem",
    fontWeight: 600,
    ...sx,
  };

  if (external) {
    return (
      <Link
        href={to}
        target="_blank"
        rel="noreferrer"
        color="primary"
        underline="hover"
        className={className}
        sx={baseSx}
      >
        {label}
        <OpenInNewIcon fontSize="inherit" />
      </Link>
    );
  }

  return (
    <Link
      component={RouterLink}
      to={to}
      color="primary"
      underline="hover"
      className={className}
      sx={baseSx}
    >
      {label}
      <ArrowForwardIcon fontSize="inherit" />
    </Link>
  );
};
